export default __webpack_public_path__ + "static/media/group-7070.f33af073.png";